module.exports = __webpack_public_path__ + "static/media/nvg-graphic-gradient-16grid.41fbf8df.png";